'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by lyj on 2016/4/21.
                                          */

// import { push } from 'react-router-redux';
//


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _payment = require('redux/modules/payment');

var paymentActions = _interopRequireWildcard(_payment);

var _components = require('components');

var _auth = require('redux/modules/auth');

var _reactRouter = require('react-router');

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentPage = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var params = _ref.params;

    var promises = [];
    promises.push(dispatch((0, _auth.load)()));
    promises.push(dispatch((0, _background.changeHeaderText)('订单支付')));
    promises.push(dispatch(paymentActions.load(params.orderNumber, params.activeId)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    submitted: state.payment.submitted,
    isAlipayModalShow: state.payment.isAlipayModalShow,
    data: state.payment.data,
    paymentData: state.payment.paymentData,
    submitting: state.payment.submitting,
    user: state.auth.user,
    error: state.payment.error
  };
}, paymentActions), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PaymentPage, _Component);

  function PaymentPage() {
    (0, _classCallCheck3.default)(this, PaymentPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PaymentPage).call(this));

    _this.state = {
      clickBtn: ''
    };
    return _this;
  }

  (0, _createClass3.default)(PaymentPage, [{
    key: 'onBtnClick',
    value: function onBtnClick(submitData) {
      var _props = this.props;
      var submit = _props.submit;
      var data = _props.data;
      var changeAlipayModalShowTrue = _props.changeAlipayModalShowTrue;

      if (data && submitData && data.info instanceof Array && data.info.length > 0) {
        (function () {
          var openPage = void 0;
          if (submitData.payPlatform === 'M0042510000000000000000002') {
            openPage = window.open('about:blank', '_blank');
          }
          submit((0, _extends3.default)({}, data.info[0], submitData), data.orderNumber, data.activeId).then(function (nextData) {
            if (nextData.isValid && submitData.payPlatform === 'M0042510000000000000000002') {
              changeAlipayModalShowTrue();
              openPage.location.href = nextData.qrc;
              // window.open(nextData.qrc);
              // this.openwin(nextData.qrc);
            }
          });
        })();
      }
    }
  }, {
    key: 'onBtnClose',
    value: function onBtnClose() {
      this.setState({
        clickBtn: ''
      });
    }
  }, {
    key: 'onWechatPaymentBtnClick',
    value: function onWechatPaymentBtnClick(btn) {
      var _props2 = this.props;
      var load = _props2.load;
      var data = _props2.data;

      this.setState({
        clickBtn: btn
      });
      if (data && load) {
        load(data.orderNumber, data.activeId);
      }
    }
  }, {
    key: 'onAlipayModalBtnClick',
    value: function onAlipayModalBtnClick(btn) {
      var _props3 = this.props;
      var load = _props3.load;
      var data = _props3.data;
      var changeAlipayModalShowFalse = _props3.changeAlipayModalShowFalse;

      this.setState({
        clickBtn: btn
      });
      // console.log('onAlipayModalBtnClick');
      // console.log(data);
      if (data && load) {
        changeAlipayModalShowFalse();
        load(data.orderNumber, data.activeId);
      }
    }
  }, {
    key: 'openwin',
    value: function openwin(url) {
      var aEle = document.createElement('a');
      aEle.setAttribute('href', url);
      aEle.setAttribute('target', '_blank');
      aEle.setAttribute('id', 'openwin');
      document.body.appendChild(aEle);
      aEle.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var data = _props4.data;
      var paymentData = _props4.paymentData;
      var user = _props4.user;
      var submitting = _props4.submitting;
      var submitted = _props4.submitted;
      var error = _props4.error;
      var params = _props4.params;
      var isAlipayModalShow = _props4.isAlipayModalShow;
      // console.log(JSON.stringify(paymentData));
      // console.log(submitted);
      // console.log(submitting);
      // console.log(isAlipayModalShow);

      var clickBtn = this.state.clickBtn;
      // console.log(clickBtn);

      var urlAdress = '';
      if (params.activeId === 'M001538') {
        urlAdress = '/orderlist/';
      } else if (params.activeId === 'M001794') {
        urlAdress = '/serviceorderlist/';
      }
      var styles = require('./PaymentPage.scss');
      var result = _react2.default.createElement(_components.WarningPage, { text: '付款信息有误' });
      if (data && data.info instanceof Array && data.info.length > 0) {
        if (data.info[0].isSuccess === '1') {
          result = _react2.default.createElement(
            _components.WarningPage,
            { text: '订单支付成功' },
            _react2.default.createElement(
              'div',
              { style: { width: '100%', padding: '0px 35%' } },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: styles.submittedSucesBtn
                  // + data.orderNumber
                  , to: urlAdress },
                '查看订单'
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: styles.submittedSucesBtn,
                  to: '/' },
                '继续购买'
              ),

              /*  clickBtn === 'back' ? <PaymentModal text="订单已经支付成功" onClose={this.onBtnClose.bind(this)}/> : '' */
              _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: clickBtn === 'back',
                loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/zhuce_sucess_1.png") no-repeat' },
                closeModalFunc: this.onBtnClose.bind(this),
                text: '订单已经支付成功' })
            )
          );
        } else {
          result = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.PaymentHeader, { orderNumber: data.orderNumber, money: data.info[0].money }),
            _react2.default.createElement(_components.PaymentContent, { info: data.info[0], initialValues: data.info[0], orderNumber: data.orderNumber,
              activeId: params.activeId,
              onSubmitData: this.onBtnClick.bind(this) }),
            error ? _react2.default.createElement(_components.ErrorLabel, { error: error }) : '',
            paymentData && paymentData.payPlatform === 'M0042510000000000000000001' ? _react2.default.createElement(_components.WechatPaymentModal, { isOpened: submitted, data: paymentData, user: user,
              onBtnClick: this.onWechatPaymentBtnClick.bind(this) }) : '',
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(_components.LoadModal, { isOpened: submitting }),
            paymentData && paymentData.payPlatform === 'M0042510000000000000000002' ? _react2.default.createElement(_components.AlipayModal, { isOpened: isAlipayModalShow, onBtnClick: this.onAlipayModalBtnClick.bind(this) }) : '',

            /* clickBtn === 'success' ? <PaymentModal text="订单没有支付成功，请继续支付" onClose={this.onBtnClose.bind(this)}/> : '' */
            _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: clickBtn === 'success',
              loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/zhuce_sucess_1.png") no-repeat' },
              closeModalFunc: this.onBtnClose.bind(this),
              text: '订单没有支付成功，请继续支付' })
          );
        }
      }
      return result;
    }
  }]);
  return PaymentPage;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  params: _react.PropTypes.object,
  paymentData: _react.PropTypes.object,
  error: _react.PropTypes.object,
  user: _react.PropTypes.object,
  location: _react.PropTypes.object,
  submitted: _react.PropTypes.bool,
  submitting: _react.PropTypes.bool,
  isAlipayModalShow: _react.PropTypes.bool,
  submit: _react.PropTypes.func,
  load: _react.PropTypes.func,
  dispatch: _react.PropTypes.func,
  changeAlipayModalShowTrue: _react.PropTypes.func,
  changeAlipayModalShowFalse: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = PaymentPage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PaymentPage/PaymentPage.js
 ** module id = 1511
 ** module chunks = 0
 **/